<template>
    <div>
        HELLO, zhopa
    </div>
</template>

<script>
export default {
    name: "About",
    data: () => ({
        
    })
}
</script>

<style>

</style>